import { Component, OnInit } from '@angular/core';
import { DialogBase } from '@routes/dialogs/dialog.base';
import Utils from '@shared/utils/utils';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Code } from '@shared/models/code';
import { MasterCode } from '@shared/enums/master-code';
import { DatePipe } from '@angular/common';
import Role from '@shared/constants/role';
import { Constants } from '@shared/constants/constants';
import { Company } from '@shared/enums/company';
import Roles from '@shared/constants/roles';
import Swal from 'sweetalert2';
import { debounceTime, distinctUntilChanged, finalize } from 'rxjs/operators';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent extends DialogBase implements OnInit {
  readonly Roles = Roles;

  title: any;
  saveButtonLabel: any;
  id: any;
  userInfo: any;
  onboarding: any;
  showOnboarding: any;
  simpleEdit: boolean = false;

  detailForm: FormGroup;
  statusGroupOptions: Code[] = [];
  userRoleGroupOptions: Code[] = [];
  organizationGroupOptions: any[] = [];
  filteredOrganizationGroupOptions: any[] = [];
  bpSelectGroup!: any;

  companies: Code[] = [];
  dealers: Code[] = [];
  profileOption = '';


  userType = null;
  returnedCompany: string = null;
  roles: Code[] = [];
  error: any;

  pipe = new DatePipe('en-US');
  company;
  loginCompanies = Company;
  addressData = {};
  country: any;
  bpTypeahead = new Subject<string>();
  allBpOptions: any[] = [];
  bps: any[] = [];

  get form() {
    return this.detailForm.controls;
  }

  ngOnInit(): void {
    this.company = this.authService.getCurrentCompany();
    this.country = this.authService.getCurrentCountry(this.company);
    this.setFormControls();
    this.setSelectOptions();

    this.bpTypeahead.pipe(
      debounceTime(200),
      distinctUntilChanged()
    ).subscribe(term => {
      console.log(`bp term = ${ term }`);
      this.filterBpOptions(term?.trim());
    });
  }

  filterBpOptions(term: string) {
    if (!term) {
      this.bpSelectGroup = [];
    } else {
      const bpIds = this.bps?.map(bp => bp.code);
      this.bpSelectGroup = this.allBpOptions.filter(bp =>
        bp.name.toLowerCase().includes(term.toLowerCase()) && !bpIds?.includes(bp.code)
      );
    }
  }


  selectRoles(event) {
    console.log(event);
    this.setCondition(event.code, true);
  }

  setFormControls() {

    let defaultControls: any = {
      username: [null, Validators.compose([Validators.required, Validators.email])],
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      tel: null,
      ext: null,
      status: [null, Validators.required],
      name: [null, Validators.compose([Validators.required])],
      mainContact: null,
      mainEmail: [null, Validators.compose([Validators.required, Validators.email])],
      role: [null, Validators.required],
      organization: [null, Validators.required],
      bps: null,
      createdAt: new FormControl({ value: ' ', disabled: true }),
      updatedAt: new FormControl({ value: ' ', disabled: true }),
      address: null,
      employeeNo: new FormControl({ value: ' ', disabled: true }),
      rejectReason: null,
      inquiryRecipient: null,
    }
    const idControl = {
      _id: [null],
    }

    if (this.userInfo) {
      defaultControls = {
        ...defaultControls,
        ...idControl,
      }
    }

    this.detailForm = this.fb.group(defaultControls);
  }

  valueRedefinition(value) {
    value = {
      ...value, address: {
        address1: (document.getElementById('edit_route') as HTMLInputElement).value,
        address2: (document.getElementById('edit_address2') as HTMLInputElement).value,
        city: (document.getElementById('edit_locality') as HTMLInputElement).value,
        state: (document.getElementById('edit_administrative_area_level_1') as HTMLInputElement).value,
        zipcode: (document.getElementById('edit_postal_code') as HTMLInputElement).value,
        country: (document.getElementById('edit_country') as HTMLInputElement).value,
      }
    };
    return value;
  }

  setSelectOptions() {
    this.apiService.master.getConstant(MasterCode.B2bRoles).subscribe(res => {
      let arr = res.filter(re => re.company.includes(this.company));
      this.userRoleGroupOptions = arr;
    });

    this.apiService.master.getConstant(MasterCode.UserStatus).subscribe(res => {
      let arr = [];
      Object.keys(res).map(function (key) {
        arr.push({ ['code']: res[key], ['name']: res[key] })
        return arr;
      });
      this.statusGroupOptions = arr;
    });

    this.apiService.master.getConstant(MasterCode.B2bPartner).subscribe(res => {
      this.organizationGroupOptions = res;

      // Initialize user data after organization options are loaded
      console.log('this.userInfo = ', this.userInfo);
      if (this.userInfo) {
        if (this.onboarding) {
          this.setOnboarding();
        }
        this.title = 'Edit';
        this.saveButtonLabel = 'Update';
        this.id = this.userInfo._id;
        this.userType = this.userInfo.userType;
        console.log('this.userInfo.bps = ', this.userInfo.bps);

        this.setEdit(this.userInfo);

        if (this.authService.getUserType() === Role.b2bCustomerAdmin) {
          this.detailForm.controls['role'].disable();
        }
      }

      this.setCondition();
    });
    this.allBpOptions = this.authService.getBpDealers().map((m) => {
      m.label = `[${ m.bpNo }] ${ m.name }`;
      return m;
    });
    this.setSelectedBps();
  }

  async submitForm($event) {
    $event.stopPropagation();
    $event.preventDefault();

    const currentCompany = this.authService.getCurrentCompany();

    let userData = this.detailForm.getRawValue();
    userData = this.valueRedefinition(userData);

    if (this.detailForm.invalid) {
      this.detailForm.markAllAsTouched();
      return;
    }

    if (this.Roles.b2bCustomerAndAdmin.includes(userData.role)) {
      if (this.bps.length === 0) {
        console.log('this.detailForm[bps] =', this.detailForm);
        this.detailForm.controls['bps'].setErrors({ required: 'Select at least one BP' });
        return;
      }

      userData.bps = this.bps?.map(m => {
        return {
          'code': m.code,
          'name': m.name,
          'bpNo': m.bpNo,
          'email': m.email
        }
      });
    }


    const b2bUser: any = {
      username: userData.username,
      tel: userData.tel,
      ext: userData.ext,
      firstName: userData.firstName,
      lastName: userData.lastName,
      status: userData.status,
      address: userData.address,
      b2bCompany: [{
        name: userData.name,
        tel: userData.mainContact,
        email: userData.mainEmail,
      }],
      roles: [
        {
          company: currentCompany,
          groups: [
            userData.role
          ]
        }
      ],
      partnerOrganization: userData.organization?.toUpperCase(),
      bps: userData.bps,
      userType: userData.role,
      inquiryRecipient: userData.inquiryRecipient,
    };

    if (this.id) {
      b2bUser._id = this.id;
    }

    this.spinnerService.start();

    if (!this.profileOption) {
      this.apiService.user.saveB2bUser(b2bUser)
        .pipe(finalize(() => this.spinnerService.stop()))
        .subscribe(res => {
          const messages = !this.userInfo ?
            { title: 'User Create', text: 'User created successfully. Registration email sent to the new user' } :
            { title: 'User Update', text: 'User updated successfully' };
          Swal.fire({
            title: messages.title,
            text: messages.text,
            icon: 'success',
            allowOutsideClick: false,
          }).then((result) => {
            this.onClose.next(res);
            this.bsModalRef.hide();
          });
        }, err => Utils.showError(err));
    } else {
      this.apiService.user.saveB2bSimpleProfile(b2bUser)
        .pipe(finalize(() => this.spinnerService.stop()))
        .subscribe(res => {
          const messages = !this.userInfo ?
            { title: 'User Create', text: 'User created successfully. Registration email sent to the new user' } :
            { title: 'User Update', text: 'User updated successfully' };
          Swal.fire({
            title: messages.title,
            text: messages.text,
            icon: 'success',
            allowOutsideClick: false,
          }).then((result) => {
            this.onClose.next(res);
            this.bsModalRef.hide();
          });
        }, err => Utils.showError(err));
    }
  }

  checkUserEmail($event) {
    const username = $event.target.value;
    if (username) {
      this.apiService.user.checkDuplicateEmail(username)
        .subscribe(res => {
        }, err => {
          Utils.showError(err);
          this.form['username'].setValue(null);
        });
    }
  }

  setBps(bp) {
    this.bps.push(bp);
    this.form['bps'].setValue(null);
  }

  setSelectedBps() {
    this.bps = this.userInfo?.bps || [];
  }

  removeBp(bpToRemove: any): void {
    this.bps = this.bps?.filter(bp => bp !== bpToRemove);
  }


  updateRequestStatus($event, result) {
    $event.stopPropagation();
    $event.preventDefault();

    const currentCompany = this.authService.getCurrentCompany();

    let userData = this.detailForm.getRawValue();
    userData = this.valueRedefinition(userData);

    if (result === 'REJECTED') {
      this.form['bps'].disable();
      this.form['bps'].setValue(null);
      if (this.form['rejectReason'].value) {

      } else {
        this.form['rejectReason'].setErrors({ required: true });
      }
    } else {
      this.form['bps'].enable();
      this.form['rejectReason'].setErrors(null);
    }

    if (this.detailForm.invalid) {
      this.detailForm.markAllAsTouched();
      return;
    }

    userData.bps = userData.bps?.map(m => {
      const tempBPSelectGroup = this.bpSelectGroup.find(f => m === f.code);
      return {
        'code': tempBPSelectGroup.code,
        'name': tempBPSelectGroup.name,
        'bpNo': tempBPSelectGroup.bpNo,
        'email': tempBPSelectGroup.email
      }
    });

    let b2bUser: any = {
      username: userData.username,
      tel: userData.tel,
      ext: userData.ext,
      firstName: userData.firstName,
      lastName: userData.lastName,
      status: userData.status,
      address: userData.address,
      b2bCompany: [{
        name: userData.name,
        tel: userData.mainContact,
        email: userData.mainEmail,
      }],
      roles: [
        {
          company: currentCompany,
          groups: [
            userData.role
          ]
        }
      ],
      partnerOrganization: userData.organization?.toUpperCase(),
      bps: userData?.bps,
      userType: userData.role
    };

    if (this.id) {
      b2bUser = {
        ...b2bUser,
        ...{ _id: this.id },
      }
    }

    b2bUser = {
      ...b2bUser,
      onboarding: {
        requestDate: this.onboarding.requestDate,
        reviewedDate: new Date(),
        rejectReason: userData.rejectReason,
        status: result,
      }
    }

    console.log('onboarding =', b2bUser);
    const title = result === 'ACCEPTED' ? 'Accepted' : 'Rejected';
    const description = result === 'ACCEPTED' ? 'Accepted Successfully' : 'Rejected Successfully';

    this.spinnerService.start();
    this.apiService.user.updateB2bRequestStatus(b2bUser.username, b2bUser)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        Swal.fire({
          title: title,
          text: description,
          icon: 'success',
          allowOutsideClick: false,
        }).then((result) => {
          this.onClose.next(null);
          this.bsModalRef.hide();

        });
      }, err => Utils.showError(err));

  }

  private setEdit(userInfo) {

    const form = this.detailForm.controls;
    userInfo.updatedAt = this.pipe.transform(userInfo.auth?.updatedAt, 'shortDate');
    userInfo.createdAt = this.pipe.transform(userInfo.auth?.createdAt, 'shortDate');

    let keyRoles = null;

    Object.keys(form).forEach(key => {
      form[key].setValue(userInfo[key]);
      if (key === 'address') {
        this.addressData = {
          address: userInfo[key]
        };
      }
      if (key === 'name') {
        form['name'].setValue(userInfo?.b2bCompany?.length > 0 ? userInfo.b2bCompany[0].name : '');
      }
      if (key === 'mainContact') {
        form['mainContact'].setValue(userInfo?.b2bCompany?.length > 0 ? userInfo.b2bCompany[0].tel : '');
      }
      if (key === 'mainEmail') {
        form['mainEmail'].setValue(userInfo?.b2bCompany?.length > 0 ? userInfo.b2bCompany[0].email : '');
      }

      if (key === 'role') {
        form['role'].setValue(userInfo?.userType);
      }

      if (key === 'organization') {
        form['organization'].setValue(userInfo?.partnerOrganization?.toUpperCase());
      }

      if (key === 'bps') {
        let returnBPs = [];
        userInfo?.selectedBPs?.map((m) => {
          returnBPs.push(m.code);
          return m;
        });
        form['bps'].setValue(returnBPs);
      }

      if (key === 'username') {
        form[key].disable();
      }

      // Onboarding Information
      if (userInfo.onboarding) {
        if (key === 'rejectReason') {
          form[key].setValue(userInfo.onboarding.rejectReason);
        }
      }
      console.log('this.showOnboarding =', this.showOnboarding);

      if (this.showOnboarding) {
        if (!['rejectReason'].includes(key)) {
          form[key].disable();
        }
      }

    });


    this.userInfo = userInfo;
  }

  private retrieveRoles(roles) {
    let returnRoles = null;
    if (roles) {
      let company = this.authService.getCurrentCompany();
      this.returnedCompany = company;
      returnRoles = roles?.find(f => f.company === company)?.groups;
    }
    return returnRoles;
  }

  private setOnboarding() {
    this.showOnboarding = true;
  }

  private setCondition(userType?: string, userSelected?: boolean) {
    userType = userType ? userType : this.userInfo?.userType;
    console.log('userType =', userType);
    let returnBPs = [];
    switch (userType) {
      case Role.admin :
      case Role.b2bRsmAdmin :
        this.form['organization'].disable();
        this.form['organization'].setValue(null);
        this.form['bps'].disable();
        this.form['bps'].setValue(returnBPs);
        this.bps = [];
        break;
      case Role.b2bCustomer :
      case Role.b2bCustomerAdmin:
        this.form['organization'].disable();
        this.form['organization'].setValue(null);
        this.form['bps'].enable();
        this.userInfo?.selectedBPs?.map((m) => {
          returnBPs.push(m.code);
          return m;
        });
        this.form['bps'].setValue(returnBPs);
        break;
      case Role.b2bPartner :
        this.filteredOrganizationGroupOptions = this.organizationGroupOptions.filter(option => option.exchange);
        this.form['organization'].enable();
        this.form['organization'].setValue(this.userInfo?.partnerOrganization?.toUpperCase());
        this.form['bps'].disable();
        this.form['bps'].setValue(returnBPs);
        if (userSelected){
          this.form['organization'].setValue(null);
          this.bps = [];
        }
        break;
      case Role.b2bSvcVendor :
        this.filteredOrganizationGroupOptions = this.organizationGroupOptions.filter(option => !option.exchange && option.rsm);
        this.form['organization'].enable();
        this.form['organization'].setValue(this.userInfo?.partnerOrganization?.toUpperCase());
        this.form['bps'].disable();
        this.form['bps'].setValue(returnBPs);
        if (userSelected){
          this.form['organization'].setValue(null);
          this.bps = [];
        }
        break;
      case Role.b2bPartnerAdmin :
        this.form['organization'].disable();
        this.form['organization'].setValue(null);
        this.form['bps'].disable();
        this.form['bps'].setValue(returnBPs);
        if (userSelected){
          this.form['organization'].setValue(null);
          this.bps = [];
        }
        break;
      default :
        break;
    }
  }

}
